import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      component: (resolve) => require(["@/views/home/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/activity",
      name: "activity",
      component: (resolve) => require(["@/views/activity/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/activity/details",
      name: "activityDetails",
      component: (resolve) =>
        require(["@/views/activity/details.vue"], resolve),
      hidden: true,
    },
    {
      path: "/library",
      name: "library",
      component: (resolve) => require(["@/views/library/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/library/content",
      name: "libraryCont",
      component: (resolve) => require(["@/views/library/content.vue"], resolve),
      hidden: true,
    },
    {
      path: "/library/details",
      name: "libraryDetails",
      component: (resolve) => require(["@/views/library/details.vue"], resolve),
      hidden: true,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/progress",
      name: "progress",
      component: (resolve) => require(["@/views/progress/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/progress/details",
      name: "progressDetails",
      component: (resolve) =>
        require(["@/views/progress/details.vue"], resolve),
      hidden: true,
    },
    {
      path: "/progress/feedback",
      name: "progressDetails",
      component: (resolve) =>
        require(["@/views/progress/feedback.vue"], resolve),
      hidden: true,
    },
    {
      path: "/progress/apply",
      name: "progressDetails",
      component: (resolve) => require(["@/views/progress/apply.vue"], resolve),
      hidden: true,
    },
    {
      path: "/notice",
      name: "notice",
      component: (resolve) => require(["@/views/notice/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/notice/details",
      name: "noticeDetails",
      component: (resolve) => require(["@/views/notice/details.vue"], resolve),
      hidden: true,
    },
    {
      path: "/introduce",
      name: "introduce",
      component: (resolve) => require(["@/views/introduce/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/introduce/details",
      name: "introduceDetails",
      component: (resolve) =>
        require(["@/views/introduce/details1.vue"], resolve),
      hidden: true,
    },
    {
      path: "/introduce/detailsTwo",
      name: "introduceDetails2",
      component: (resolve) =>
        require(["@/views/introduce/details2.vue"], resolve),
      hidden: true,
    },
    {
      path: "/introduce/detailsHandle",
      name: "introduceDetails3",
      component: (resolve) =>
        require(["@/views/introduce/details3.vue"], resolve),
      hidden: true,
    },
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/views/login/index.vue"], resolve),
      hidden: true,
    },
    {
      path: "/login/business",
      name: "business",
      component: (resolve) => require(["@/views/login/business.vue"], resolve),
      hidden: true,
    },
    {
      path: "/login/specialist",
      name: "specialist",
      component: (resolve) =>
        require(["@/views/login/specialist.vue"], resolve),
      hidden: true,
    },
    {
      path: "/login/perfect",
      name: "perfect",
      component: (resolve) => require(["@/views/login/perfect.vue"], resolve),
      hidden: true,
    },
    {
      path: "/login/reset",
      name: "reset",
      component: (resolve) => require(["@/views/login/reset.vue"], resolve),
      hidden: true,
    },
    {
      path: "/sign",
      name: "sign",
      component: (resolve) => require(["@/views/sign/index.vue"], resolve),
      hidden: true,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 };
  },
});

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js